import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { goBack, push } from "connected-react-router";
import { toast } from "react-toastify";
import ROUTES from "../../../../../routes";
import {
  BoxSeparator,
  ContentBox,
  Page,
  TitleBox,
  Button,
  ForbiddenSection,
  Box,
  EmptyMessage,
  NoTCModal,
  RadioGroupComponent,
  BorderedCheckbox,
  Tooltip
} from "../../../../../components";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { business as businessActions } from "../../../../../actions";
import { Language } from "../../../../../utils";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import makeClasses from "./styles";
import { Policies } from "../../../../../utils/Policies";
import { Autocomplete } from "@material-ui/lab";
import clsx from "clsx";
import { uniqueId } from "lodash";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import { ReactComponent as PersonFilledIcon } from "../../../../../static/images/icons/person-filled.svg";
import { ReactComponent as CalendarMonthFilled } from "../../../../../static/images/icons/calendar_month-fill.svg";
import { ReactComponent as CalendarTodayFilled } from "../../../../../static/images/icons/calendar_today-fill.svg";

const CURRENCY_DEFAULT_OPTION = {
  id: "URUGUAYAN_PESO",
  name: "Currency.UYU",
  currency: "UYU",
};

const CURRENCY_FILTER_OPTIONS = [
  { id: "URUGUAYAN_PESO", name: "Currency.UYU", currency: "UYU" },
  { id: "DOLLAR", name: "Currency.USD", currency: "USD" },
];

const VAT_VALUES = [0, 10, 22];

const VAT_TAX_MULTIPLIER = {
  0: 1,
  10: 1.1,
  22: 1.22,
};

const VAT_DEFAULT_VALUE = 22;

const VAT_FILTER_OPTIONS = [
  { id: 22, name: "22%" },
  { id: 10, name: "10%" },
  { id: 0, name: "0%" },
];

const FREQUENCE_FILTER_OPTIONS = [
  { id: "MONTHLY", name: "Frequency.MONTHLY", active: true },
  { id: "ANNUAL", name: "Frequency.ANNUAL", active: true },
  { id: "WEEKLY", name: "Frequency.WEEKLY", active: true },
  { id: "QUARTERLY", name: "Frequency.QUARTERLY", active: true },
  { id: "SEMIANNUAL", name: "Frequency.SEMIANNUAL", active: true },
  { id: "HOURLY", name: "Frequency.HOURLY", active: false },
  { id: "DAILY", name: "Frequency.DAILY", active: false },
];

const DURATION_FILTER_OPTIONS = [
  { id: 0, name: "0" },
  { id: 1, name: "1" },
  { id: 2, name: "2" },
  { id: 3, name: "3" },
  { id: 4, name: "4" },
  { id: 5, name: "5" },
  { id: 6, name: "6" },
  { id: 7, name: "7" },
  { id: 8, name: "8" },
  { id: 9, name: "9" },
  { id: 10, name: "10" },
  { id: 11, name: "11" },
  { id: 12, name: "12" },
];

const FIELD_TYPES_OPTIONS = [
  {
    id: "STRING",
    name: "ProvidersManageSubscribersRequestNewCharge.AdditionalFieldTypeOption1",
  },
  {
    id: "INTEGER",
    name: "ProvidersManageSubscribersRequestNewCharge.AdditionalFieldTypeOption2",
  },
];

const ProvidersSubscriptionsAddPlanScreen = ({ match }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();

  const planTraceId =
    match.params && match.params.traceId ? match.params.traceId : null;
  const isEditMode = planTraceId !== null;

  const [inputName, setInputName] = useState(null);
  const [inputDescription, setInputDescription] = useState(null);
  const [inputBranch, setInputBranch] = useState(null);
  const [inputCurrency, setInputCurrency] = useState(null);
  const [inputAmount, setInputAmount] = useState(null);
  const [inputTaxableAmount, setInputTaxableAmount] = useState(null);
  const [inputVat, setInputVat] = useState(22);
  const [inputFrequency, setInputFrequency] = useState(null);
  const [inputCode, setInputCode] = useState(null);
  const [inputGroup, setInputGroup] = useState(null);
  const [inputDuration, setInputDuration] = useState(null);
  const [inputCallback, setInputCallback] = useState(false);
  const [inputCallbackUrl, setInputCallbackUrl] = useState(null);
  const [inputPaymentDate, setInputPaymentDate] = useState(null);
  const [additionalData, setAdditionalData] = useState([]);
  const [forbiddenSection, setForbbidenSection] = useState(false);
  const [planTerms, setPlanTerms] = useState(null);
  const [branches, setBranches] = useState([]);
  const [planDetails, setPlanDetails] = useState(null);
  const [planBranchTraceId, setPlanBranchTraceId] = useState(null)
  const [showTCModal, setShowTCModal] = useState(false);
  const [validCurrencies, setValidCurrencies] = useState([]);
  const [isMultipleSubscriptionsEnabled, setIsMultipleSubscriptionsEnabled] =
    useState(false);
  const [multipleSubscriptionAdditionalData, setMultipleSubscriptionAdditionalData] = useState(null)
  const [allowPlanChange, setAllowPlanChange] = useState(true)
  const { policies, languageTexts } = useSelector((state) => ({
    policies: state.user.userData.policies || [],
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);
  const editTermsUrl = ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS_PLAN_EDIT_TERMS_CONDITIONS.path.replace(":traceId", planTraceId);
  const [selectedPaymentDay, setSelectedPaymentDay] = useState("");
  const PAYMENT_DAY_OPTIONS = [
    {
      label: i18n.get(
        "ProvidersSubscriptionsAddPlan.PaymentDayOptions.FixedDay"
      ),
      value: "fixed-day",
      description: i18n.get(
        "ProvidersSubscriptionsAddPlan.PaymentDayOptions.FixedDayDescription"
      ),
      icon: <CalendarTodayFilled />,
      disabled: isEditMode,
      additionalInput: (
        <TextField
          InputLabelProps={{
            shrink: true,
          }}
          className={[classes.formInput, classes.extraTextField]}
          label={i18n.get(
            "ProvidersSubscriptionsAddPlan.PaymentDateInputLabel"
          )}
          placeholder={i18n.get(
            "ProvidersSubscriptionsAddPlan.PaymentDateInputPlaceholder"
          )}
          onChange={handleOnChangePaymentDate}
          value={inputPaymentDate}
          helperText={i18n.get(
            "ProvidersSubscriptionsAddPlan.PaymentDateInputHelp"
          )}
          disabled={isEditMode}
          type="number"
        />
      ),
    },
    {
      label: i18n.get(
        "ProvidersSubscriptionsAddPlan.PaymentDayOptions.SuscriptionDay"
      ),
      value: "suscription-day",
      description: i18n.get(
        "ProvidersSubscriptionsAddPlan.PaymentDayOptions.SuscriptionDayDescription"
      ),
      icon: <CalendarMonthFilled />,
      disabled: isEditMode && selectedPaymentDay === "fixed-day",
    },
    {
      label: i18n.get(
        "ProvidersSubscriptionsAddPlan.PaymentDayOptions.ClientChosen"
      ),
      value: "client-chosen",
      description: i18n.get(
        "ProvidersSubscriptionsAddPlan.PaymentDayOptions.ClientChosenDescription"
      ),
      icon: <PersonFilledIcon />,
      disabled: isEditMode && selectedPaymentDay === "fixed-day",
    },
  ];

  const canSubmitForm = !isEditMode
    ? inputName &&
      inputName.length > 0 &&
      inputName.length <= 50 &&
      inputDescription &&
      inputDescription.length > 0 &&
      inputDescription.length <= 500 &&
      inputBranch &&
      inputCurrency &&
      VAT_VALUES.includes(inputVat) &&
      inputAmount > 0 &&
      inputFrequency &&
      (!isMultipleSubscriptionsEnabled || (isMultipleSubscriptionsEnabled && additionalData.some((data) => data.required)))
    : inputDescription && inputDescription.length > 0 && inputBranch;

  const isFixedDayMissing =
    inputFrequency === "MONTHLY" &&
    selectedPaymentDay === "fixed-day" &&
    !inputPaymentDate;

  const hasUniqueKeys = (fields) => {
    const keys = fields
      .filter((field) => field.key)
      .map((field) => field.key.trim().toLowerCase());
    return keys.length === new Set(keys).size;
  };

  const hasCompletedAdditionalData =
    additionalData.length > 0
      ? additionalData.every(
          (field) =>
            field.name &&
            field.name.length > 0 &&
            field.name.length <= 50 &&
            field.key &&
            field.key.length > 0 &&
            field.key.length <= 50 &&
            field.type &&
            field.type.length > 0 &&
            field.type.length <= 50
        ) && hasUniqueKeys(additionalData)
      : true;

  const calculateVat = (taxAmount, taxableAmount) => {
    if (taxableAmount === 0) {
      return 0;
    }

    const vat = (taxAmount / taxableAmount) * 100;
    if (VAT_VALUES.includes(Math.round(vat))) {
      return Math.round(vat);
    } else {
      return VAT_DEFAULT_VALUE;
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    if (
      policies &&
      policies.includes(Policies.types.PROVIDERS_SUBSCRIPTIONS_PLANS_WRITE)
    ) {
      dispatch(
        businessActions.getProvidersSubscriptionsMerchant((dataBranches) => {
          if (isEditMode) {
            dispatch(
              businessActions.getProvidersSubscriptionsPlan(
                planTraceId,
                (data) => {
                  if (data) {
                    setPlanDetails(data);

                    setInputName(data.name);
                    setInputDescription(data.description);
                    setInputBranch(data.branchTraceId);
                    setInputCurrency(data.currency);
                    setInputAmount(data.amount);
                    setInputTaxableAmount(data.taxableAmount);
                    setInputVat(
                      calculateVat(data.taxAmount, data.taxableAmount)
                    );
                    setInputFrequency(data.frequence);
                    setInputCode(data.code);
                    setInputGroup(data.group);
                    setInputDuration(data.duration);
                    setInputPaymentDate(data.paymentDay);
                    if (data.callbackUrl) {
                      setInputCallback(true);
                      setInputCallbackUrl(data.callbackUrl);
                    }
                    if (data.additionalFields?.length > 0) {
                      const sortedFields = [...data.additionalFields].sort((a, b) => {
                        if (a.required === b.required) return 0;
                        return a.required ? -1 : 1;
                      });
                      setAdditionalData(sortedFields);
                    }
                    if (data.multiplesSubscriptionsEnabled) {
                      setIsMultipleSubscriptionsEnabled(data.multiplesSubscriptionsEnabled)
                      setMultipleSubscriptionAdditionalData(data.additionalFields?.find((field) => field.required))
                    }
                    setAllowPlanChange(data.allowChange)

                    if (
                      data.frequence === "MONTHLY" &&
                      data.userSelectablePaymentDay
                    ) {
                      setSelectedPaymentDay("client-chosen");
                    } else if (
                      data.frequence === "MONTHLY" &&
                      data.paymentDay
                    ) {
                      setSelectedPaymentDay("fixed-day");
                    } else if (data.frequence === "MONTHLY") {
                      setSelectedPaymentDay("suscription-day");
                    }

                    dispatch(
                      businessActions.getPlanTermsAndConditions(
                        planTraceId,
                        (link) => {
                          if (link) {
                            setPlanTerms(link);
                          }
                        }
                      )
                    );
                  }
                }
              )
            );
          }
          setBranches(
            dataBranches.branches
              ?.filter((b) => b.serviceStatus === "ACTIVE")
              ?.map((b) => ({ traceId: b.branchId, name: b.name })) || []
          );
        })
      );
    } else {
      setForbbidenSection(true);
    }
  }, [policies]);

  const _goBack = (e) => {
    e.preventDefault();
    dispatch(goBack());
  };

  const _submitForm = () => {
    if (!canSubmitForm) {
      return false;
    }

    if (isEditMode) {
      if (!inputDescription || !inputBranch || !VAT_VALUES.includes(inputVat)) {
        return toast.error(
          i18n.get("ProvidersSubscriptionsAddPlan.FormValidationError")
        );
      }
    } else {
      if (
        !inputName ||
        !inputDescription ||
        !inputBranch ||
        !inputCurrency ||
        !VAT_VALUES.includes(inputVat) ||
        !inputAmount ||
        !inputFrequency
      ) {
        return toast.error(
          i18n.get("ProvidersSubscriptionsAddPlan.FormValidationError")
        );
      }
    }

    if (isEditMode) {
      const taxMultiplier = VAT_TAX_MULTIPLIER[inputVat] || 1;
      delete planDetails.paymentDay;
      const params = {
        ...planDetails,
        branchTraceId: inputBranch,
        description: inputDescription,
        callbackUrl: inputCallback ? inputCallbackUrl : "",
        taxableAmount: parseFloat(
          (parseFloat(inputAmount) / taxMultiplier).toFixed(2)
        ),
        taxAmount: parseFloat(
          (
            parseFloat(inputAmount) -
            parseFloat(inputAmount) / taxMultiplier
          ).toFixed(2)
        ),
        additionalFields: additionalData.map((field) => ({
          key: field.key,
          name: field.name,
          type: field.type,
          required: field.required
        })),
        userSelectablePaymentDay: selectedPaymentDay === "client-chosen",
        allowChange: allowPlanChange
      };

      dispatch(
        businessActions.providersSubscriptionsUpdatePlan(
          planTraceId,
          params,
          (result) => {
            if (result) {
              toast.success(
                i18n.get("ProvidersSubscriptionsAddPlan.SuccessUpdateMessage")
              );
              setTimeout(
                () =>
                  dispatch(
                    push(ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS_PLANS.path)
                  ),
                1000
              );
            }
          }
        )
      );
    } else {
      const taxMultiplier = inputVat === 0 ? 1 : inputVat === 22 ? 1.22 : 1.1;
      const params = {
        branchTraceId: inputBranch,
        name: inputName,
        subscriptionPlanType: "TRADITIONAL",
        additionalFields: additionalData.map((field) => ({
          key: field.key,
          name: field.name,
          type: field.type,
          required: field.required
        })),
        frequence: inputFrequency,
        taxableAmount: parseFloat(
          (parseFloat(inputAmount) / taxMultiplier).toFixed(2)
        ),
        taxAmount: parseFloat(
          (
            parseFloat(inputAmount) -
            parseFloat(inputAmount) / taxMultiplier
          ).toFixed(2)
        ),
        currency: inputCurrency,
        description: inputDescription,
        duration: inputDuration,
        anticipatedCancellationEnable: true,
        code: inputCode,
        group: inputGroup,
        paymentDay: inputPaymentDate ? parseInt(inputPaymentDate) : null,
        tags: null,
        callbackUrl: inputCallback ? inputCallbackUrl : "",
        userSelectablePaymentDay: selectedPaymentDay === "client-chosen",
        multiplesSubscriptionsEnabled: isMultipleSubscriptionsEnabled,
        allowChange: allowPlanChange
      };

      dispatch(
        businessActions.providersSubscriptionsAddPlan(
          params,
          (result, hasTC) => {
            if (result) {
              if (hasTC) {
                toast.success(
                  i18n.get("ProvidersSubscriptionsAddPlan.SuccessAddMessage")
                );
                setTimeout(
                  () =>
                    dispatch(
                      push(ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS_PLANS.path)
                    ),
                  1000
                );
              } else {
                setPlanBranchTraceId(result.subscriptionPlanTraceId)
                setShowTCModal(true);
              }
            }
          }
        )
      );
    }
  };

  const handlePaymentDayChange = (value) => {
    if (value !== "fixed-day") {
      setInputPaymentDate(null);
    }
    setSelectedPaymentDay(value);
  };

  const toggleTCModal = () => {
    setShowTCModal(!showTCModal);
  };

  const _getOptionLabel = (array) => (option) => {
    let foundOption = null;
    if (array === "branches") {
      foundOption = branches.find((c) => c.traceId === option);
      return foundOption?.name || foundOption?.internalName || "";
    } else if (array === "currencies") {
      foundOption = CURRENCY_FILTER_OPTIONS.find((c) => c.id === option);
      return i18n.get(foundOption.name);
    } else if (array === "vat") {
      foundOption = VAT_FILTER_OPTIONS.find((c) => c.id === option);
      return foundOption.name;
    } else if (array === "frequencies") {
      foundOption = FREQUENCE_FILTER_OPTIONS.find((c) => c.id === option);
      return i18n.get(foundOption.name);
    } else if (array === "durations") {
      foundOption = DURATION_FILTER_OPTIONS.find((c) => c.id === option);
      return foundOption.name;
    }

    return "";
  };

  const _isKeyDuplicated = (key, currentIndex) => {
    const normalizedKey = key?.trim().toLowerCase();
    return additionalData.some(
      (field, index) =>
        index !== currentIndex &&
        field.key?.trim().toLowerCase() === normalizedKey
    );
  };

  const _handleOnChangeFrequency = (e, newValue) => {
    setInputFrequency(newValue);
  };

  const _handleOnChangeCurrency = (e, newValue) => {
    setInputCurrency(newValue);
  };

  const _handleOnChangeVat = (e, newValue) => {
    setInputVat(newValue);
    if (newValue !== null) {
      const foundOption = VAT_FILTER_OPTIONS.find((c) => c.id === newValue);
      setInputTaxableAmount(
        parseFloat(
          foundOption.id === 0
            ? 0
            : (parseFloat(inputAmount) / (1 + foundOption.id / 100)).toFixed(2)
        )
      );
    }
  };

  const handleOnChangeInputAmount = (e) => {
    const value = parseFloat(e.target.value);
    if (isNaN(value) || value > 0) {
      setInputAmount(value);
      if (inputVat) {
        const foundOption = VAT_FILTER_OPTIONS.find((c) => c.id === inputVat);
        setInputTaxableAmount(
          parseFloat(
            foundOption.id === 0
              ? 0
              : (parseFloat(value) / (1 + foundOption.id / 100)).toFixed(2)
          )
        );
      }
    }
  };

  const _handleOnChangeBranch = (e, newValue) => {
    setInputBranch(newValue);
    if (newValue) {
      dispatch(
        businessActions.getPaymentLinkRestrictions(newValue, (restrictions) => {
          const currencies = restrictions.currencies || [];
          setValidCurrencies([...currencies, CURRENCY_DEFAULT_OPTION.currency]);
          if (currencies.length === 0) {
            setInputCurrency(CURRENCY_DEFAULT_OPTION.id);
          }
          if (currencies.length === 1) {
            const selectedCurrency = currencies[0];
            const selectedInputValue = CURRENCY_FILTER_OPTIONS.find(
              (option) => option.currency === selectedCurrency
            );
            setInputCurrency(selectedInputValue?.id || undefined);
          }
        })
      );
    } else {
      setValidCurrencies([]);
    }
  };

  const _handleOnChangeDuration = (e) => {
    const value = parseInt(e.target.value);
    if (isNaN(value) || value > 0) {
      setInputDuration(value);
    }
  };

  const handleMultipleSubscriptionsChange = (e) => {
    setIsMultipleSubscriptionsEnabled(e.target.checked);
    if (!e.target.checked) {
      const updatedAdditionalData = additionalData.map((item) => ({
        ...item,
        required: false,
      }));
      setAdditionalData(updatedAdditionalData);
    }
  };

  const _handleOnAddNewField = () => {
    setAdditionalData([
      ...additionalData,
      { id: uniqueId(), name: "", fieldName: "", type: "STRING" },
    ]);
  };

  const _handleOnClickRemove = (index) => () => {
    setAdditionalData([
      ...additionalData.slice(0, index),
      ...additionalData.slice(index + 1),
    ]);
  };

  const _handleOnAdditionalFieldChange = (index, field) => (e) => {
    const updatedField = {
      ...additionalData[index],
      [field]: e.target.value,
    };

    if (field === "required") {
      updatedField.required = e.target.checked;

      if (e.target.checked) {
        const selectedItem = additionalData[index];
        const otherItems = additionalData.filter(
          (_, itemIndex) => itemIndex !== index
        );

        const updatedAdditionalData = [
          { ...selectedItem, required: true },
          ...otherItems.map((item) => ({ ...item, required: false })),
        ];
        setAdditionalData(updatedAdditionalData);
        return;
      }
    }

    if (field === "type") {
      updatedField.value = "";
    }

    setAdditionalData([
      ...additionalData.slice(0, index),
      updatedField,
      ...additionalData.slice(index + 1),
    ]);
  };

  function handleOnChangePaymentDate(e) {
    const value = parseInt(e.target.value);
    if (isNaN(value) || (value >= 1 && value <= 28)) {
      setInputPaymentDate(value);
    }
  }

  const handleTCModalSave = async ({file, selectedTyCOption}) => {

    if (selectedTyCOption === 'plan') {
      dispatch(
        businessActions.uploadPlanTermsAndConditions(
          planBranchTraceId,
          file,
          (result) => {
            if (result) {
              toast.success(
                i18n.get("ProvidersSubscriptionsAddPlan.SuccessAddMessage")
              );
              setTimeout(
                () =>
                  dispatch(
                    push(ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS_PLANS.path)
                  ),
                1000
              );
            }
          }
        )
      )
    }

    if (selectedTyCOption === 'branch') {
      dispatch(
        businessActions.providersSubscriptionsAddTermsAndConditions(
          inputBranch,
          file,
          (result) => { 
            if (result) {
              toast.success(i18n.get("Components.NoTCModal.SuccessAddMessage"));
              setTimeout(
                () =>
                  dispatch(
                    push(ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS_PLANS.path)
                  ),
                400
              );
            }
          }
        )
      );
    }


  }

  const displayValue = (v) =>
    inputAmount && typeof v === "number" && !isNaN(v) ? v : "-";

  const renderMainForm = () => {
    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.formWrapper}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <form
            layout="vertical"
            onSubmit={_submitForm}
            className={classes.form}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={4}>
                {isEditMode ? (
                  <div
                    className={clsx(
                      classes.planDetailsItem,
                      classes.planDetailsItemDisabled
                    )}>
                    <div>
                      {i18n.get("ProvidersSubscriptionsAddPlan.NameInputLabel")}
                    </div>
                    {inputName || "-"}
                  </div>
                ) : (
                  <TextField
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className={classes.formInput}
                    label={i18n.get(
                      "ProvidersSubscriptionsAddPlan.NameInputLabel"
                    )}
                    placeholder={i18n.get(
                      "ProvidersSubscriptionsAddPlan.NameInputPlaceholder"
                    )}
                    onChange={(e) => setInputName(e.target.value)}
                    value={inputName}
                    inputProps={{ maxLength: 50 }}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={classes.formInput}
                  label={i18n.get(
                    "ProvidersSubscriptionsAddPlan.DescriptionInputLabel"
                  )}
                  placeholder={i18n.get(
                    "ProvidersSubscriptionsAddPlan.DescriptionInputPlaceholder"
                  )}
                  onChange={(e) => setInputDescription(e.target.value)}
                  value={inputDescription}
                  inputProps={{ maxLength: 500 }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Autocomplete
                  options={branches.map((c) => c.traceId)}
                  getOptionLabel={_getOptionLabel("branches")}
                  onChange={_handleOnChangeBranch}
                  classes={{ inputRoot: classes.formInputSelect }}
                  value={inputBranch}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className={classes.formInput}
                      classes={{ root: classes.formInput }}
                      label={i18n.get(
                        "ProvidersSubscriptionsAddPlan.BranchInputLabel"
                      )}
                      placeholder={i18n.get(
                        "ProvidersSubscriptionsAddPlan.BranchInputPlaceholder"
                      )}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <div className={classes.formInputSeparator} />
            <div className={classes.formInputSeparator} />
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={4}>
                {isEditMode ? (
                  <div
                    className={clsx(
                      classes.planDetailsItem,
                      classes.planDetailsItemDisabled
                    )}>
                    <div>
                      {i18n.get(
                        "ProvidersSubscriptionsAddPlan.CurrencyInputLabel"
                      )}
                    </div>
                    {inputCurrency
                      ? i18n.get(
                          CURRENCY_FILTER_OPTIONS.find(
                            (c) => c.id === inputCurrency
                          )?.name
                        )
                      : "-"}
                  </div>
                ) : (
                  <Autocomplete
                    options={CURRENCY_FILTER_OPTIONS.filter((c) =>
                      validCurrencies.includes(c.currency)
                    ).map((c) => c.id)}
                    getOptionLabel={_getOptionLabel("currencies")}
                    onChange={_handleOnChangeCurrency}
                    classes={{ inputRoot: classes.formInputSelect }}
                    value={inputCurrency}
                    noOptionsText={i18n.get(
                      "ProvidersSubscriptionsAddPlan.BranchInputPlaceholder"
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className={classes.formInput}
                        classes={{ root: classes.formInput }}
                        label={i18n.get(
                          "ProvidersSubscriptionsAddPlan.CurrencyInputLabel"
                        )}
                        placeholder={i18n.get(
                          "ProvidersSubscriptionsAddPlan.CurrencyPlaceholder"
                        )}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={classes.formInput}
                  label={i18n.get(
                    "ProvidersSubscriptionsAddPlan.AmountInputLabel"
                  )}
                  placeholder={i18n.get(
                    "ProvidersSubscriptionsAddPlan.AmountInputPlaceholder"
                  )}
                  onChange={handleOnChangeInputAmount}
                  value={inputAmount}
                  type="number"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Autocomplete
                  options={VAT_FILTER_OPTIONS.map((c) => c.id)}
                  getOptionLabel={_getOptionLabel("vat")}
                  onChange={_handleOnChangeVat}
                  classes={{ inputRoot: classes.formInputSelect }}
                  value={inputVat}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className={classes.formInput}
                      classes={{ root: classes.formInput }}
                      label={i18n.get(
                        "ProvidersSubscriptionsAddPlan.VatInputLabel"
                      )}
                      placeholder={i18n.get(
                        "ProvidersSubscriptionsAddPlan.VatInputPlaceholder"
                      )}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <div
                  className={clsx(
                    classes.planDetailsItem,
                    classes.planDetailsItemDisabled
                  )}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsAddPlan.TaxableAmountLabel"
                    )}
                  </div>
                  {displayValue(inputTaxableAmount)}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                {isEditMode ? (
                  <div
                    className={clsx(
                      classes.planDetailsItem,
                      classes.planDetailsItemDisabled
                    )}>
                    <div>
                      {i18n.get(
                        "ProvidersSubscriptionsAddPlan.FrequencyInputLabel"
                      )}
                    </div>
                    {inputFrequency
                      ? i18n.get(
                          FREQUENCE_FILTER_OPTIONS.find(
                            (f) => f.id === inputFrequency
                          )?.name || inputFrequency
                        )
                      : "-"}
                  </div>
                ) : (
                  <Autocomplete
                    options={FREQUENCE_FILTER_OPTIONS.filter(
                      (o) => o.active
                    ).map((c) => c.id)}
                    getOptionLabel={_getOptionLabel("frequencies")}
                    onChange={_handleOnChangeFrequency}
                    classes={{ inputRoot: classes.formInputSelect }}
                    value={inputFrequency}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className={classes.formInput}
                        classes={{ root: classes.formInput }}
                        label={i18n.get(
                          "ProvidersSubscriptionsAddPlan.FrequencyInputLabel"
                        )}
                        placeholder={i18n.get(
                          "ProvidersSubscriptionsAddPlan.FrequencyPlaceholder"
                        )}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                )}
              </Grid>
              {isEditMode ? (
                <Grid item xs={12} sm={12} md={3}>
                  <div className={classes.planDetailsItem}>
                    <div>
                      {i18n.get(
                        "ProvidersSubscriptionsAddPlan.TermsInputLabel"
                      )}
                      :
                    </div>
                    {planTerms ? (
                      <div className={classes.planTermsContainer}>
                        <a href={planTerms} target="_blank" rel="noreferrer">
                          {i18n.get(
                            "ProvidersSubscriptionsAddPlan.TermsInputValue"
                          )}
                        </a>
                        {isEditMode && <a href={editTermsUrl} rel="noreferrer">
                          {i18n.get(
                            "ProvidersSubscriptionsAddPlan.TermsEditInputValue"
                          )}
                        </a>}
                      </div>
                    ) : (
                      "-"
                    )}
                  </div>
                </Grid>
              ) : null}
            </Grid>
          </form>
        </Grid>
      </Grid>
    );
  };

  const renderOptionalForm = () => {
    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.formWrapper}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <form
            layout="vertical"
            onSubmit={_submitForm}
            className={classes.form}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={4}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={classes.formInput}
                  label={i18n.get(
                    "ProvidersSubscriptionsAddPlan.CodeInputLabel"
                  )}
                  placeholder={i18n.get(
                    "ProvidersSubscriptionsAddPlan.CodeInputPlaceholder"
                  )}
                  onChange={(e) => setInputCode(e.target.value)}
                  value={inputCode}
                  inputProps={{ maxLength: 25 }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={classes.formInput}
                  label={i18n.get(
                    "ProvidersSubscriptionsAddPlan.GroupInputLabel"
                  )}
                  placeholder={i18n.get(
                    "ProvidersSubscriptionsAddPlan.GroupInputPlaceholder"
                  )}
                  onChange={(e) => setInputGroup(e.target.value)}
                  value={inputGroup}
                  inputProps={{ maxLength: 25 }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                {isEditMode ? (
                  <div
                    className={clsx(
                      classes.planDetailsItem,
                      classes.planDetailsItemDisabled
                    )}>
                    <div>
                      {i18n.get(
                        "ProvidersSubscriptionsAddPlan.DurationInputLabel"
                      )}
                    </div>
                    {/[0-9]+/.test(inputDuration) ? inputDuration : "-"}
                  </div>
                ) : (
                  <TextField
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className={classes.formInput}
                    label={i18n.get(
                      "ProvidersSubscriptionsAddPlan.DurationInputLabel"
                    )}
                    placeholder={i18n.get(
                      "ProvidersSubscriptionsAddPlan.DurationInputPlaceholder"
                    )}
                    onChange={_handleOnChangeDuration}
                    value={inputDuration}
                    type="number"
                  />
                )}
              </Grid>
            </Grid>
            <div className={classes.formInputSeparator} />
            <div className={classes.formInputSeparator} />
            <Grid container spacing={4}> 
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className={classes.callbackCheckboxWrapper}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={inputCallback}
                      onChange={() => setInputCallback(!inputCallback)}
                    />
                  }
                  label={i18n.get(
                    "ProvidersSubscriptionsAddPlan.CallbackInputLabel"
                  )}
                  classes={{ label: classes.autoApprovalLabel }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <div
                  className={
                    !inputCallback
                      ? classes.autoApprovalInputDisabledWrapper
                      : null
                  }>
                  <TextField
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={!inputCallback}
                    className={classes.formInput}
                    label={i18n.get(
                      "ProvidersSubscriptionsAddPlan.CallbackUrlInputLabel"
                    )}
                    placeholder={i18n.get(
                      "ProvidersSubscriptionsAddPlan.CallbackUrlInputPlaceholder"
                    )}
                    onChange={(e) => setInputCallbackUrl(e.target.value)}
                    value={inputCallback ? inputCallbackUrl : ""}
                  />
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className={classes.callbackCheckboxWrapper}>
                  <div className={classes.checkboxContainer}>
                    <FormControlLabel
                    control={
                      <Checkbox
                        checked={allowPlanChange}
                        onChange={(e, checked) => setAllowPlanChange(checked)}
                      />
                    }
                    label={i18n.get('ProvidersSubscriptionsAddPlan.ChangePlanLabel')}
                    classes={{ label: classes.autoApprovalLabel }}
                    />
                    <Tooltip title={i18n.get('ProvidersSubscriptionsAddPlan.ChangePlanTooltip')}>
                      <InfoOutlinedIcon />
                    </Tooltip>
                  </div>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    );
  };

  const CircleCheckedIcon = () => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
          fill="currentColor"
        />

        <g transform="translate(12 12) scale(0.6) translate(-12 -12)">
          <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" fill="#fff" />
        </g>
      </svg>
    );
  };

  const renderAdditionalDataForm = () => {
    if (additionalData.length === 0) {
      return (
        <EmptyMessage showShadow={false}>
          {i18n.get("ProvidersSubscriptionsAddPlan.AdditionalDataNoFields")}
        </EmptyMessage>
      );
    }

    return (
      <div>
        {additionalData.length > 0
          ? additionalData.map((field, index) =>{
              return ((isEditMode && !field.required) || !isEditMode) && <div key={index} className={classes.additionalFieldWrapper}>
                <div className={classes.additionalFieldContent}>
                  <div
                    className={clsx(
                      classes.additionalFieldNumber,
                      field.required && classes.additionalFieldNumberSelected
                    )}>
                    {isEditMode ? index : index + 1}
                  </div>
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={12} md={4}>
                      <TextField
                        InputLabelProps={{
                          shrink: true,
                        }}
                        className={classes.formInput}
                        label={i18n.get(
                          "ProvidersSubscriptionsAddPlan.AdditionalFieldNameInputLabel"
                        )}
                        placeholder={i18n.get(
                          "ProvidersSubscriptionsAddPlan.AdditionalFieldNameInputPlaceholder"
                        )}
                        value={field.name}
                        onChange={_handleOnAdditionalFieldChange(index, "name")}
                        inputProps={{ maxLength: 50 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                      <TextField
                        InputLabelProps={{
                          shrink: true,
                        }}
                        className={classes.formInput}
                        label={i18n.get(
                          "ProvidersSubscriptionsAddPlan.AdditionalFieldInternalNameInputLabel"
                        )}
                        placeholder={i18n.get(
                          "ProvidersSubscriptionsAddPlan.AdditionalFieldInternalNameInputPlaceholder"
                        )}
                        value={field.key}
                        onChange={_handleOnAdditionalFieldChange(index, "key")}
                        inputProps={{ maxLength: 50 }}
                        error={_isKeyDuplicated(field.key, index)}
                        helperText={_isKeyDuplicated(field.key, index) ? i18n.get("ProvidersSubscriptionsAddPlan.KeyAlreadyExists") : ""}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                      <InputLabel
                        className={classes.formInputSelectLabel}
                        shrink>
                        {i18n.get(
                          "ProvidersSubscriptionsAddPlan.AdditionalFieldTypeInputLabel"
                        )}
                      </InputLabel>
                      <Select
                        className={classes.formInputSelect}
                        onChange={_handleOnAdditionalFieldChange(index, "type")}
                        value={field.type}>
                        {FIELD_TYPES_OPTIONS.map((fieldType, index) => (
                          <MenuItem
                            key={index}
                            value={fieldType.id}
                            className={classes.formInputSelectOption}>
                            {i18n.get(fieldType.name)}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </Grid>
                </div>
                <div className={classes.additionalFieldActions}>
                  <div>
                    {isMultipleSubscriptionsEnabled && !isEditMode && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            className={classes.checkbox}
                            checked={field.required === true}
                            onChange={_handleOnAdditionalFieldChange(
                              index,
                              "required"
                            )}
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<CircleCheckedIcon />}
                          />
                        }
                        label="Dato identificador"
                      />
                    )}
                  </div>
                  <IconButton onClick={_handleOnClickRemove(index)}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6C4.71667 6 4.47917 5.90417 4.2875 5.7125C4.09583 5.52083 4 5.28333 4 5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4H9C9 3.71667 9.09583 3.47917 9.2875 3.2875C9.47917 3.09583 9.71667 3 10 3H14C14.2833 3 14.5208 3.09583 14.7125 3.2875C14.9042 3.47917 15 3.71667 15 4H19C19.2833 4 19.5208 4.09583 19.7125 4.2875C19.9042 4.47917 20 4.71667 20 5C20 5.28333 19.9042 5.52083 19.7125 5.7125C19.5208 5.90417 19.2833 6 19 6V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM17 6H7V19H17V6ZM10 17C10.2833 17 10.5208 16.9042 10.7125 16.7125C10.9042 16.5208 11 16.2833 11 16V9C11 8.71667 10.9042 8.47917 10.7125 8.2875C10.5208 8.09583 10.2833 8 10 8C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V16C9 16.2833 9.09583 16.5208 9.2875 16.7125C9.47917 16.9042 9.71667 17 10 17ZM14 17C14.2833 17 14.5208 16.9042 14.7125 16.7125C14.9042 16.5208 15 16.2833 15 16V9C15 8.71667 14.9042 8.47917 14.7125 8.2875C14.5208 8.09583 14.2833 8 14 8C13.7167 8 13.4792 8.09583 13.2875 8.2875C13.0958 8.47917 13 8.71667 13 9V16C13 16.2833 13.0958 16.5208 13.2875 16.7125C13.4792 16.9042 13.7167 17 14 17Z"
                        fill="#D02E30"
                      />
                    </svg>
                  </IconButton>
                </div>
              </div>
            })
          : null}
      </div>
    );
  };

  if (forbiddenSection) {
    return (
      <Page
        withHeader
        withSidebar
        withHeaderTitle={i18n.get("ProvidersSubscriptionsAddPlan.Title")}
        withActivePage={ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS.id}
        withBanner={false}>
        <ForbiddenSection />
      </Page>
    );
  }

  return (
    <Page
      withHeader
      withSidebar
      withHeaderTitle={i18n.get("ProvidersSubscriptionsAddPlan.Title")}
      withActivePage={ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS.id}>
      <TitleBox
        title={
          isEditMode
            ? i18n.get("ProvidersSubscriptionsAddPlan.BoxTitleEdit")
            : i18n.get("ProvidersSubscriptionsAddPlan.BoxTitleNew")
        }
        back
        backTitle={i18n.get("ProvidersSubscriptionsAddPlan.BoxBackButton")}
        onBackClick={_goBack}
        backButtonVariant="outlined"
      />
      <BoxSeparator size="small" />
      <Box direction="column">
        <ContentBox
          title={i18n.get("ProvidersSubscriptionsAddPlan.MainFormTitle")}
          titleBold
          showShadow={false}
          padding={false}>
          {renderMainForm()}
        </ContentBox>
        <BoxSeparator type="line" />
        {inputFrequency === "MONTHLY" && (
          <>
            <ContentBox
              title={i18n.get(
                "ProvidersSubscriptionsAddPlan.PaymentDayFormTitle"
              )}
              titleBold
              showShadow={false}
              padding={false}>
              <RadioGroupComponent
                value={selectedPaymentDay}
                onChange={handlePaymentDayChange}
                options={PAYMENT_DAY_OPTIONS}
                label={i18n.get(
                  "ProvidersSubscriptionsAddPlan.PaymentDayFormTitle"
                )}
              />
            </ContentBox>
            <BoxSeparator type="line" />
          </>
        )}
        <ContentBox
          title={i18n.get("ProvidersSubscriptionsAddPlan.OptionalFormTitle")}
          titleBold
          showShadow={false}
          padding={false}>
          {renderOptionalForm()}
        </ContentBox>
        {isEditMode ? multipleSubscriptionAdditionalData &&
          <div className={classes.multipleSubsContainer}>
            <div>{i18n.get('ProvidersSubscriptionsPlanDetails.PlanBoxMultipleSubscriptionAdditionalFieldBoxTitle')}</div>
            <BoxSeparator type="line" lineSize="small"/>
            <div className={classes.additionalTextLabel}>
              {i18n.get('ProvidersSubscriptionsPlanDetails.PlanBoxMultipleSubscriptionAdditionalFieldLabel')}
            </div>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={4}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsPlanDetails.PlanBoxAdditionalDataNameLabel"
                    )}
                    :
                  </div>
                  {multipleSubscriptionAdditionalData?.name || "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsPlanDetails.PlanBoxAdditionalDataInternalNameLabel"
                    )}
                    :
                  </div>
                  {multipleSubscriptionAdditionalData?.key || "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsPlanDetails.PlanBoxAdditionalDataTypeLabel"
                    )}
                    :
                  </div>
                  {multipleSubscriptionAdditionalData?.type
                    ? i18n.get(
                        FIELD_TYPES_OPTIONS.find(
                          (s) => s.id === multipleSubscriptionAdditionalData?.type
                        ).name
                      )
                    : "-"}
                </div>
              </Grid>
            </Grid>
          </div> :
        <ContentBox showShadow={false} padding={false}>
          <div className={classes.formInputSeparator} />
          <div className={classes.formInputSeparator} />
          <BorderedCheckbox
            checked={isMultipleSubscriptionsEnabled}
            onChange={handleMultipleSubscriptionsChange}
          />
        </ContentBox>}
        <BoxSeparator type="line" />
        <ContentBox
          title={i18n.get(
            "ProvidersSubscriptionsAddPlan.AdditionalDataFormTitle"
          )}
          titleBold
          button
          buttonText={i18n.get(
            "ProvidersSubscriptionsAddPlan.AdditionalDataButton"
          )}
          buttonLeftIcon={() => <AddIcon fontSize="small" />}
          buttonOnClick={_handleOnAddNewField}
          showShadow={false}
          padding={false}>
          {renderAdditionalDataForm()}
        </ContentBox>
        <BoxSeparator type="line" />
        <div className={classes.contentActionsWrapper}>
          <Button variant="outlined" onClick={_goBack}>
            {i18n.get("ProvidersSubscriptionsAddPlan.CancelButton")}
          </Button>
          <div className={classes.contentActionSeparator} />
          <Button
            disabled={
              !canSubmitForm || !hasCompletedAdditionalData || isFixedDayMissing
            }
            onClick={_submitForm}>
            {isEditMode
              ? i18n.get("ProvidersSubscriptionsAddPlan.SaveButton")
              : i18n.get("ProvidersSubscriptionsAddPlan.CreateButton")}
          </Button>
        </div>
      </Box>
      <NoTCModal
        open={showTCModal}
        onClose={toggleTCModal}
        onSave={handleTCModalSave}
      />
    </Page>
  );
};

ProvidersSubscriptionsAddPlanScreen.id =
  "com.Handy.ProvidersSubscriptionsAddPlan";

export default ProvidersSubscriptionsAddPlanScreen;
